import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { AssetListComponent } from './assets-list/asset-list.component';
import { RightsGuard } from 'src/app/core/guards/rights.guard';
import { AssetDetailComponent } from './asset-detail/asset-detail.component';
import { TimeSlotSelectorComponent } from './asset-service-appointment/timeslot-selector/timeslot-selector.component';
import { AppointmentConfirmationComponent } from './asset-service-appointment/appointment-confirmation/appointment-confirmation.component';

const routes: Routes = [
  {
    path: 'asset-list',
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [
      { path: '', component: AssetListComponent },
      { path: ':id', component: AssetDetailComponent },
    ],
  },
  {
    path: 'asset/serviceAppointment',
    children: [
      {
        path: 'timeslot/:contractItemExternalEntityId',
        canActivate: [AuthorizeGuard],
        component: TimeSlotSelectorComponent,
      },
      // { path: 'confirmation', canActivate: [AuthorizeGuard], component: AppointmentConfirmationComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AssetsRoutingModule {}
